import {FaFacebook, FaInstagram, FaLinkedin} from 'react-icons/fa'
import styles from "./Footer.module.css"
import Player from '../layout/player.js'

function Footer(){
    return (
        <footer className={styles.footer}>
            <ul className={styles.social_list}>
                <li>
                    <FaFacebook />
                </li >
                <li>
                    <FaInstagram />                    
                </li>
                <li>
                    <FaLinkedin />
                </li>
            </ul>
            <div><Player /></div>

            <p className={styles.copy_right}>
                <span>welber.dev</span> &copy; 2024</p>
        </footer>
       
        
    )
}
export default Footer